import styled from 'styled-components';

import { IconButton } from '@/ui/Button';

export const Close = styled(IconButton).attrs({
  buttonVariant: 'dark',
  icon: 'xmark',
  // The only content is an aria-hidden glyph, so without this the button has no accessible name.
  'aria-label': 'Close',
})`
  grid-area: close;
  justify-self: right;
  align-self: center;
  transform: translateX(12px);
`;
